import classNames from "../../utils/classNames";

// A UK rear plate: yellow, monospaced. The only place the dashboard uses a monospace face.
export default function RegPlate({ vrm, size = "sm" }: { vrm?: string | null; size?: "sm" | "lg" }) {
  if (!vrm) return null;

  return (
    <span
      className={classNames(
        "inline-block rounded bg-[#f7d117] font-mono font-bold uppercase tracking-wide text-gray-900",
        size === "lg" ? "px-2 py-0.5 text-[15px]" : "px-1.5 py-px text-xs"
      )}
    >
      {vrm.replace(/\s+/g, "").toUpperCase()}
    </span>
  );
}
